import { createSelector } from 'reselect'
import entryDataSelector from '../entryDataSelector'

const orderUrlSelector = createSelector(
    entryDataSelector,
    (entryData): string | undefined => entryData.links?.find(link => link.id === "orderUrl")?.value,
)

export default orderUrlSelector
